<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="tablePath">自选职业推送列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">{{$route.meta.title}}</template>
      <div class="device device-iphone-x">
        <div class="device-frame">
          <div class="mobile-container">
            <div style="display: flex; align-items: center; flex-direction: column">
              <h1>{{detail.title}}</h1>
              <p>{{detail.detail}}</p>
            </div>
            <div class="occupations-list">
              <div class="occupations-list-item" v-for="occupation in detail.occupations">
                <img :src="occupation.image_url" alt="" width="90" heigth="90">
                <p>{{occupation.name}}</p>
              </div>
            </div>
          </div>
          <div class="occupations-submit">我选好了</div>
        </div>
        <div class="device-stripe"></div>
        <div class="device-header"></div>
        <div class="device-sensors"></div>
        <div class="device-btns"></div>
        <div class="device-power"></div>
      </div>
    </layout-panel>
    <router-link :to="tablePath">
      <el-button type="primary">返回</el-button>
    </router-link>
  </div>
</template>

<script>
export default {
  components: {},
  mixins: [],
  data () {
    return {
      tablePath: '/users/occupation-questionnaire/table',
      detail: {
        title: '',
        detail: '',
        occupations: []
      }
    }
  },
  computed: Vuex.mapState({}),
  created () {
    this.id = this.$route.params.id
    this.id > 0 && this.setDetailData(this.id)
  },
  methods: {
    ...Vuex.mapActions([]),
    setDetailData (id) {
      request.page('previewOccupationQuestionnaire', {id}).then(({data}) => {
        filter.setLoop(this.detail, data)
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
@import '@core/style/devices/devices.scss';

.device {
  .mobile-container {
    padding: 20px;
    border-radius: 40px;
    background-color: #FFF;
    height: 100%;
    cursor: all-scroll;
    overflow: scroll;
    h1 {
      margin-top: 100px;
    }
    .occupations-list {
      display: flex;
      flex-direction: row;
      align-items: left;
      flex-wrap: wrap;
      .occupations-list-item {
        width: 100px;
        padding: 10px;
        text-align: center
      }
    }
  }
  .occupations-submit {
    background: rgb(212,161,70);
    color: #FFF;
    width: 100%;
    text-align: center;
    position: relative;
    bottom: 35px;
    height: 35px;
    line-height: 35px;
    border-radius: 0 0 40px 40px;
  }
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/occupation-questionnaire/pages/OccupationQuestionnairePreview.vue